import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import SarasTrans from '../../../library/notifications/SarasTrans';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormLink from '../../../library/form/components/FormLink';
import FormLabel from '../../../library/form/components/FormLabel'
import FormTitle from '../../../library/form/components/FormTitle';
import FormStatus from '../../../library/form/components/FormStatus';
import DocFormReview from "../../cmn/docReviewStatus/DocFormReview"
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColOne, UiCol } from "../../../library/layout/Index";
import FormWrapper from '../../../library/form/components/FormWrapper';
import DocAdminInfo from '../../cmn/DocAdminInfo';

const ProHeader1View = (props) => {
    const { formObject } = props;

    return (
        <>

            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <span>
                            <FormTitle formObject={formObject} value='Main Detail' />
                        </span>
                    </UiTitle>

                    <UiAction>
                        <DocAdminInfo formObject={formObject} rowKey="" headerKey="adminInfo"/>
                        <FormButton formObject={formObject} ksc="h" rowKey="" starIcon={"edit"}
                            action={{ actionId: "edit",  actionParam: {}, containerKey: "popup" }}
                            className="uiActionIconButton" text={<SarasTrans value="Edit" />}></FormButton>
                    </UiAction>

                </UiViewHeading>
                <UiViewContent>
                    <UiGridColOne>
                        <UiCol>
                            <ul>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="ID" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className='uiHighlightKey'/>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "refCode" }} className='uiSpacerH10'/>
                                    <br />
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "parentProfile" }} value="Parent ID" />
                                    </span>
                                    <FormLink formObject={formObject} rowKey="" linkProp={{ target: "_blank" }} qvIconKey="person"
                                        action={{ paramName: "parentProfile", actionId: "show", actionName: "proComp",  containerKey: "custom", actionParam: { showModeID: "qv" } }}
                                    />
                                </li>
                                <li id="vWorkflowStatusContainer" >
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "review" }} value="Review" />
                                    </span>
                                    <DocFormReview formObject={formObject} />
                                    <span className="uiLblInLine">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "status" }} value="Status" />
                                    </span>
                                    <FormStatus formObject={formObject} rowKey="" headerKey="docStatus"/>
                                    
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "company" }} value="Account Name" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "company" }} />
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "priority" }} className="uiPriority"/>
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nickName" }} value="Nick Name" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "nickName" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profileCategory" }} value="Category 1" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "profileCategory" }} />
                                </li>
                                <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "profileCategory2" }} >
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "profileCategory2" }} value="Category 2" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "profileCategory2" }} />
                                </FormWrapper>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refChannel" }} value="Channel" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "refChannel" }} />
                                </li>

                                <li>
                                    <span className="uiLbl" >
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "relationWith" }} value="Account Owner" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "relationWith" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "relationSince" }} value="Account Since" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "relationSince" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "website" }} value="Website" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "website" }} />
                                </li>
                                <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "businessDetail" }} >
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "businessDetail" }} value="Business Details" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "businessDetail" }} />
                                </FormWrapper>

                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remark" }} value="Remarks 1" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "remark" }} />
                                </li>
                                <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "remark2" }} >
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remark2" }} value="Remarks 2" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "remark2" }} />
                                </FormWrapper>
                                <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "remark3" }} >
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "remark3" }} value="Remarks 3" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "remark3" }} />
                                </FormWrapper>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "acCompany" }} value="Company" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "acCompany" }} />
                                </li>
                                <li id="svSendNotify" >
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "notify" }} value="Send Notification" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "notify" }} />

                                    <span className="uiLblInLine">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isCompany" }} value="Is Company" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "isCompany" }} />
                                </li>
                                <li>
                                    <span className="uiLbl">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "createdBy" }} value="Created By" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "createdBy" }} />
                                    <span className="uiLblInLine">
                                        <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sortOrder" }} value="Sort No" />
                                    </span>
                                    <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "sortOrder" }}/>
                                </li>
                            </ul>
                        </UiCol>
                    </UiGridColOne>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProHeader1View, "proHeader", "proHeader");